import { useInstance } from '@meraki-internal/react-dependency-injection';
import { JournalIcon } from '../../theme/Icons';
import { IPeriodData } from '../model/IPeriodData';
import { Stat } from './Stat';
import { CheckinState } from '../model/CheckinState';

export const EntryCount: React.FC<{selectedPeriod: IPeriodData}> = ({ selectedPeriod }) => {

    const checkinState = useInstance(CheckinState);

    // merge checkin dates from both collections
    const datesWithData = new Set<string>();
    for (const checkins of [selectedPeriod.personal, selectedPeriod.care]) {
        for (const checkin of checkins) {
            if (checkinState.hasData(checkin)) {
                datesWithData.add(checkin.timestamp.substring(0, 10));
            }
        }
    }

    const count = datesWithData.size;

    return (
        <Stat
            data-id="entry-count-stat"
            label={count !== 1 ? 'journal entries' : 'journal entry'}
            value={count}
            Icon={JournalIcon}
            iconColor="theme-teal"
        />
    );
};
